import LayoutNoFooter from '@/page/layout/index'
import MobilePreview from "@/views/iframe/MobilePreview.vue";
export default [
    {
        path: '/biange',
        name: 'biange',
        component: LayoutNoFooter,
        children: [
            {
                path: 'key',
                name: 'biange-key',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/biange/key'),
                props: route => ({
                }),
                meta: {
                    title: '关键小事',
                    isAuth: false,
                }
            },
            {
                path: 'group',
                name: 'biange-group',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/biange/group'),
                props: route => ({
                }),
                meta: {
                    title: '公众督导团',
                    isAuth: false,
                }
            },
            {
                path: 'group/detail',
                name: 'biange-group-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/biange/groupDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            },
            {
                path: 'doctor',
                name: 'biange-doctor',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/biange/doctor'),
                props: route => ({
                }),
                meta: {
                    title: '督学问诊',
                    isAuth: false,
                }
            },
            {
                path: "/preview",
                component: MobilePreview,
                meta: {
                    title: '督学之家',
                    isAuth: false,
                }
            }
        ]
    },
]
